import React, { Component } from 'react';
// react component that creates a form divided into multiple steps
import StepZilla from 'react-stepzilla';
import { DataAPI } from 'services/DataService.jsx';
import{
    Grid, Row, Col
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';

import Step1 from './Step1.jsx';
import Step2 from './Step2.jsx';
import Step3 from './Step3.jsx';

import { ProjectAPI } from 'services/ApiService.jsx';
import { Authenticator } from 'services/AuthService.jsx'
import { withRouter } from 'react-router-dom';
import { EventBus, EVENT_TYPE } from 'services/EventService.jsx';

import Log from 'services/Log.jsx'



class ProjectWizard extends Component{
  constructor(props) {
    super(props);
    this.state = {
      creating: false,
      plans: [],
      billingAgreement: {},
      uid: "",
      selectedPlan: {},
      tos: false,
      user: ""
    };
    this.projectData = {
      project_name: "",
      project_plan: 1,
      promo_code: ""
    };
    this.loading = true;
    this.uid = "";
  }

  getPlans() {
    DataAPI.getPlans((response) => {
        Log.debug(JSON.stringify(response));
        if (response.success) {
          this.setState({plans: response.data.plans});
        }
    });
  }

  setProjectName(projectName) {
    this.projectData = {
      project_name: projectName,
      project_plan: this.projectData.project_plan,
      promo_code: this.projectData.promo_code
    };
  }

  setTos(tosbox) {
    this.setState({tos: tosbox});
  }
  generateBillingAgreement() {
    var uid = this.state.plans[parseInt(this.projectData.project_plan.value, 10)]['uid'];
    Log.debug("UID " + uid);

    DataAPI.getBillingAgreement({data: uid}, (response) => {
        Log.debug(JSON.stringify(response));
        this.loading = false;
        if (response.success) {
            this.setState({billingAgreement: response.data});
        }
    });
  }
  setProjectPlan(projectPlan) {
    this.loading = true;
    this.projectData = {
      project_name: this.projectData.project_name,
      project_plan: projectPlan,
      promo_code: this.projectData.promo_code
    };
    var uid = this.state.plans[parseInt(this.projectData.project_plan.value, 10)]['uid'];
    this.uid = uid;
    this.setState({uid: uid});
    Log.debug("uid: " + uid);
    Log.debug(projectPlan);
    this.setState({selectedPlan: this.state.plans[parseInt(this.projectData.project_plan.value, 10)]});
    // this.generateBillingAgreement();
  }
  setProjectPromo(projectPromo) {
    this.projectData = {
      project_name: this.projectData.project_name,
      project_plan: this.projectData.project_plan,
      promo_code: projectPromo
    };
  }

  componentDidMount() {
    this.getPlans();
    window.Paddle.Setup({ vendor: 38653 });
    Authenticator.getUser((userData) => {
      this.setState({user: userData.email});
    });
  }


  openCheckout() {
    let self = this;
    window.Paddle.Checkout.open({
			product: this.state.selectedPlan.gatewayId,
			email: this.state.user,
      successCallback: function(data) {
      console.log(data);
        self.createProject(data.checkout.id);
      },
      closeCallback: function(data) {
        console.log(data);
      }
		});
  }

  createProject(paymentAuthorizationToken) {
    ProjectAPI.createProject({
      name: this.projectData.project_name,
      plan: this.state.uid,
      token: paymentAuthorizationToken,
      tos: this.state.tos
    }, (response) => {
      Log.debug(JSON.stringify(response));
      if (response.success) {
        Authenticator.refreshUser((user) => {
            EventBus.emit(EVENT_TYPE.USER_DATA);
            this.props.history.push("/dashboard");
        });
      }
    });
  }
    render(){
      const steps = [
          { name: 'Project Name', component: <Step1 setProjectName={(projectName) => {this.setProjectName(projectName)}} setTos={(tosbox) => {this.setTos(tosbox)}}/>},
          { name: 'Plan', component: <Step2 setProjectPlan={(projectPlan) => {this.setProjectPlan(projectPlan)}} plans={this.state.plans}/>},
          { name: 'Review', component: <Step3 openCheckout={this.openCheckout.bind(this)} setProjectPromo={(projectPromo) => {this.setProjectPromo(projectPromo)}} submitProject={(token) => {this.createProject(token)}} isCreating={this.state.creating} projectDetails={this.state.selectedPlan} loading={this.loading} uid={this.state.uid}/>}
      ];

        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col md={8} mdOffset={2}>
                            <Card
                                wizard
                                id="wizardCard"
                                textCenter
                                title="Create a New Project"
                                category=""
                                content={
                                    <StepZilla
                                        steps={steps}
                                        stepsNavigation={false}
                                        preventEnterSubmission={true}
                                        nextButtonCls="btn btn-prev btn-info btn-fill pull-right btn-wd"
                                        backButtonCls="btn btn-next btn-default btn-fill pull-left btn-wd"
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default withRouter(ProjectWizard);



// WEBPACK FOOTER //
// ./src/views/Forms/Wizard/ProjectWizard.jsx